import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=6a0e847d"
var script = {}
import style0 from "./DataProtection.vue?vue&type=style&index=0&id=6a0e847d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports